import { render, staticRenderFns } from "./MessageItemLinkStoryView.vue?vue&type=template&id=6b5ec17c&scoped=true&"
import script from "./MessageItemLinkStoryView.vue?vue&type=script&lang=ts&"
export * from "./MessageItemLinkStoryView.vue?vue&type=script&lang=ts&"
import style0 from "./MessageItemLinkStoryView.vue?vue&type=style&index=0&id=6b5ec17c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5ec17c",
  null
  
)

export default component.exports